/**
 * BuildScenarioRowSliderStyles - Styled components for the scenario row slider component.
 *
 * ARCHITECTURE:
 * - Provides layout components for slider container.
 * - Integrates with the existing theme system.
 */

import styled from '@emotion/styled'

// Container for the entire slider component
export const SliderContainer = styled.div`
  height: 2rem;
  display: flex;
  align-items: center;
  width: 37rem;
  height: 5rem;
`

// Horizontal container for slider and input
export const SliderInputHStack = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
  align-items: center;
`
